import type { Country } from 'react-phone-number-input'
import type { FieldValues } from 'react-hook-form'
import { useFormContext } from 'react-hook-form'
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form'
import FieldError, { RequiredMark } from './FieldError'

interface PhoneNumberFieldProps {
	name?: string
	label?: string
	containerClassName?: string
	labelClassName?: string
	defaultCountry?: Country
	placeholder?: string
	disabled?: boolean
	required?: boolean
	autoComplete?: string
}

const PhoneNumberField = ({
	name = 'phoneNumber',
	label = 'Phone Number',
	containerClassName = 'form-field',
	labelClassName = 'form-label',
	defaultCountry = 'US',
	placeholder = 'Enter phone number',
	disabled = false,
	required = false,
	autoComplete = 'tel',
}: PhoneNumberFieldProps) => {
	const {
		control,
		formState: { errors },
	} = useFormContext<FieldValues>()

	return (
		<div className={containerClassName}>
			<label className={labelClassName} htmlFor={name}>
				{label}
				{required && <RequiredMark />}
			</label>
			<div className={errors[name] ? 'phone-input-auth phone-input-auth--error' : 'phone-input-auth'}>
				<PhoneInputWithCountry
					name={name}
					control={control}
					rules={{
						required: required ? 'Phone number is required' : false,
					}}
					defaultCountry={defaultCountry}
					placeholder={placeholder}
					autoComplete={autoComplete}
					disabled={disabled}
					limitMaxLength
					international={false}
				/>
			</div>
			<FieldError errors={errors} name={name} />
		</div>
	)
}

export default PhoneNumberField
